
import styled from "styled-components"

export const Wrapper = styled.div`
  padding-bottom: 80px;
  .main-container {
  }
`